import type {
  ColoredMaterial,
  SalesOpportunity,
  TaskCategory,
  TaskCreateProps,
} from "@color-finder/color-finder-api/models";
import type { AxiosInstance } from "axios";
import type {
  DigitalSample,
  DigitalSampleAsset,
} from "../hooks/digital-samples";

// Re-declared locally because Storybook's Rollup build cannot resolve the
// const enum through the CJS __exportStar barrel (same pattern as tracking.ts).
const TaskCategoryValue = {
  DIGITAL_SCAN_REQUEST: "Z083" as TaskCategory,
  DIGITAL_SAMPLE_REQUEST: "Z084" as TaskCategory,
} as const;

export const attachDigitalSampleDownloadToOpportunity = async (
  axios: AxiosInstance,
  opportunity: SalesOpportunity,
  material: ColoredMaterial,
  digitalSample: DigitalSample,
  asset: DigitalSampleAsset,
) => {
  if (!material.material.shortGrade) {
    return;
  }

  const color =
    material.color.finalColorCode ?? material.color.preliminaryColorCode;
  const request: TaskCreateProps = {
    subject: `Digital Sample Request: ${material.material.shortGrade} ${color} ${digitalSample.materialFinish}`,
    category: TaskCategoryValue.DIGITAL_SAMPLE_REQUEST,
    colorGrade: material.material.shortGrade,
    covestroColorNumber: color,
    uvpNumber: material.availability.productNumber ?? "",
    attachments: [
      {
        name: asset.fileName,
        url: `${window.location.origin}/downloads/digital-sample/${digitalSample.id}/assets/${asset.id}`,
      },
    ],
  };
  return axios.put(`/v0/sales-opportunities/${opportunity.id}/tasks`, request);
};

export const attachDigitalSampleRequestToOpportunity = async (
  axios: AxiosInstance,
  opportunity: SalesOpportunity,
  material: ColoredMaterial,
  finish: string,
  comment: string | undefined,
) => {
  if (!material.material.shortGrade) {
    return;
  }

  const color =
    material.color.finalColorCode ?? material.color.preliminaryColorCode;
  const request: TaskCreateProps = {
    subject: `Digital Sample Scan Request: ${material.material.shortGrade} ${color} ${finish}`,
    category: TaskCategoryValue.DIGITAL_SCAN_REQUEST,
    colorGrade: material.material.shortGrade,
    covestroColorNumber: color,
    uvpNumber: material.availability.productNumber ?? "",
    note: comment,
  };
  return axios.put(`/v0/sales-opportunities/${opportunity.id}/tasks`, request);
};
